<template lang="pug">
.card
	.card-header.bg-info.text-white
		.row
		.col.text-left Facturación
		.col.text-right
			button.btn.btn-sm(
			:class="FacturacionEnNeto ? 'btn-dark' : ''",
			@click="FacturacionEnNeto = !FacturacionEnNeto"
			) Trabajar en neto
	table.table.table-striped.m-0
		thead
		tr
			th Fecha de factura
			th Importe con impuestos
			th Importe neto
			th
		tbody
		tr(
			v-for="(linea, i) in contrato.facturacion",
			:key="linea.FacturacionID"
		)
			td
				datepicker(
					:ref="'picker' + linea.FacturacionID",
					:monday-first="true",
					:id="'fecha' + linea.FacturacionID",
					:name="'fecha' + linea.FacturacionID",
					:bootstrap-styling="true",
					v-model="contrato.facturacion[i].FechaFactura",
					@input="seleccionaFecha(linea, $event)",
					:disabledDates="MesesBloqueados",
					minimum-view="month",
					:disabled="!editable(linea)",
					:language="$dateLang"
				)
			td
				input.form-control(
					:disabled="!editable(linea) || FacturacionEnNeto",
					v-model.number="contrato.facturacion[i].ImporteTotal",
					placeholder="Importe total",
					@keyup="calculaImporteTotal()"
				)
			td
				input.form-control(
					:disabled="!editable(linea) || !FacturacionEnNeto",
					placeholder="Importe neto",
					v-model="contrato.facturacion[i].ImporteNeto",
					@keyup="calculaImporteTotal()"
				)
			td.text-right
				button.btn.btn-danger.btn-block(
					v-if="editable(linea)",
					@click="quitar(linea)"
				)
					span.fa.fa-trash.mr-2
					| Quitar

				.alert.p-1.m-0.text-center.alert-primary(v-if="linea.FechaPagada") Factura pagada
		tbody
			tr.bg-white
				td
				td
					b(v-if="!FacturacionEnNeto") {{ ImportePendiente | currency }} pendiente total
				td
					b(v-if="FacturacionEnNeto") {{ ImportePendienteNeto | currency }} pendiente neto
				td
	.card-footer
		button.btn.btn-primary(@click="nuevo")
			| Nuevo
		button.btn.btn-warning.ml-2(
			@click="repartirTotal",
			v-if="!FacturacionEnNeto"
		)
			| Repartir total
		button.btn.btn-warning.ml-2(@click="repartirNeto", v-else)
			| Repartir neto
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['contrato', 'importe', 'diaFacturacion', 'importeNeto'],
	data () {
		return {
	  FacturacionEnNeto: false
		}
	},
	created () {
		this.calculaImporteTotal()
	},
	computed: {
		...mapGetters({
	  permisos: 'permisos/permisos'
		}),
		MesesBloqueados () {
	  if (!this.permisos.contratos_ignoraCierre) {
				return {
		  to: new Date()
				}
	  }
	  return {}
		},
		ImportePendiente () {
	  let pendiente = Math.round((this.importe - this.totalFacturacion) * 100)
	  return pendiente / 100
		},
		ImportePendienteNeto () {
	  let pendiente = Math.round(
				(this.importeNeto - this.totalFacturacionNeto) * 100
	  )
	  return pendiente / 100
		},
		totalFacturacion () {
	  let importe = 0
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				let importeF
				try {
		  importeF = !this.contrato.facturacion[i].ImporteTotal
						? 0
						: parseFloat(this.contrato.facturacion[i].ImporteTotal)
				} catch (e) {
		  console.error(e)
				}
				importe = importe + importeF
	  }
	  return this.round(importe, 2)
		},
		totalFacturacionNeto () {
	  let importe = 0
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				let importeF
				try {
		  importeF = !this.contrato.facturacion[i].ImporteNeto
						? 0
						: parseFloat(this.contrato.facturacion[i].ImporteNeto)
				} catch (e) {
		  console.error(e)
				}
				importe = importe + importeF
	  }
	  return this.round(importe, 2)
		}
	},
	watch: {
		diaFacturacion (newVal) {
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				const linea = this.contrato.facturacion[i]
				const picker = this.$refs['picker' + this.contrato.facturacion[i].FacturacionID][0]
				if (!picker) {
		  continue
				}
				const editar = this.contrato
				editar.facturacion = editar.facturacion.map((l) => {
		  if (l.FacturacionID === linea.FacturacionID) {
						l.FechaFactura = new Date(picker.selectedDate.getTime())
		  }
		  return l
				})
				this.$emit('update:contrato', editar)
	  }
		}
	},
	methods: {
		nuevo () {
	  this.contrato.facturacion.push({
				FacturacionID: 'L-' + new Date().getTime().toString(),
				FechaFactura: null,
				ImporteBruto: null,
				ImporteNeto: null,
				ImporteTotal: null
	  })
		},
		editable (linea) {
	  if (linea.FechaPagada) {
				return false
	  }
	  const fechaLimite = new Date()
	  fechaLimite.setDate(1)
	  fechaLimite.setDate(fechaLimite.getDate() - 1)

	  if (
				!linea.FechaFactura ||
		linea.FechaFactura > fechaLimite ||
		this.permisos.contratos_ignoraCierre
	  ) {
				return true
	  }

	  return false
		},
		quitar (linea) {
	  const editor = this.contrato
	  editor.facturacion = editor.facturacion.filter((r) => r !== linea)
	  this.$emit('update:contrato', editor)
		},
		seleccionaFecha (linea, ev) {
	  const editar = this.contrato

	  // Cambiamos la fecha al final del mes
	  if (this.diaFacturacion > 0) {
				// SER EMPRESARIOS SE FACTURA EL DÍA 15
				ev.setDate(this.diaFacturacion)
	  } else {
				ev.setDate(1)
				ev.setMonth(ev.getMonth() + 1)
				ev.setDate(ev.getDate() + this.diaFacturacion)
	  }
	  editar.facturacion = editar.facturacion.map((l) => {
				if (l.FacturacionID === linea.FacturacionID) {
		  l.FechaFactura = ev
				}
				return l
	  })
	  this.$emit('update:contrato', editar)
		},
		/**
	 * Repartimos el importe neto total del contrato entre los meses de facturación
	 */
		repartirTotal () {
	  /**
	   * Redondeamos a dos decimales
	   */
	  const importe = this.FacturacionEnNeto ? this.importeNeto : this.importe
	  if (this.contrato.facturacion.length === 0) {
				return
	  }

	  if (importe === 0) {
				return
	  }
	  let importeRestante = importe + 0

	  // Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
	  // TODO: Esta condición debería ser la de que si están cobrados o no
	  let totalFacturacion = 0
	  let acumulado = 0
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				if (
		  this.editable(this.contrato.facturacion[i]) &&
		  this.contrato.facturacion[i].FechaFactura
				) {
		  totalFacturacion++
				} else if (this.contrato.facturacion[i].Importe) {
		  importeRestante =
			importeRestante - this.contrato.facturacion[i].ImporteTotal
				} else if (!this.editable(this.contrato.facturacion[i])) {
		  importeRestante =
			importeRestante - this.contrato.facturacion[i].ImporteTotal
				}
	  }

	  // Calculamos el importe por meses
	  const media = this.round(importeRestante / totalFacturacion, 2)
	  let cantidad = media
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				if (
		  this.editable(this.contrato.facturacion[i]) &&
		  this.contrato.facturacion[i].FechaFactura
				) {
		  if (i === this.contrato.facturacion.length - 1) {
						// Si es la última línea
						// Es el último, redondeamos
						cantidad = this.round(importeRestante - acumulado, 2)
		  }
		  this.contrato.facturacion[i].ImporteTotal = this.round(cantidad, 2)
		  acumulado = this.round(acumulado + cantidad, 2)
				}
	  }

	  this.calculaImporteTotal()

	  this.$emit('update:contrato', this.contrato)

	  this.$forceUpdate()
		},

		repartirNeto () {
	  /**
	   * Redondeamos a dos decimales
	   */
	  const importe = this.importeNeto
	  if (this.contrato.facturacion.length === 0) {
				return
	  }

	  if (importe === 0) {
				return
	  }
	  let importeRestante = importe + 0

	  // Calculamos el total de recibos que podemos modificar (no están pasados de fecha)
	  // TODO: Esta condición debería ser la de que si están cobrados o no
	  let totalFacturacion = 0
	  let acumulado = 0
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				if (
		  this.editable(this.contrato.facturacion[i]) &&
		  this.contrato.facturacion[i].FechaFactura
				) {
		  totalFacturacion++
				} else if (this.contrato.facturacion[i].Importe) {
		  importeRestante =
			importeRestante - this.contrato.facturacion[i].ImporteNeto
				} else if (!this.editable(this.contrato.facturacion[i])) {
		  importeRestante =
			importeRestante - this.contrato.facturacion[i].ImporteNeto
				}
	  }

	  // Calculamos el importe por meses
	  const media = this.round(importeRestante / totalFacturacion, 2)
	  let cantidad = media
	  for (let i = 0; i < this.contrato.facturacion.length; i++) {
				if (
		  this.editable(this.contrato.facturacion[i]) &&
		  this.contrato.facturacion[i].FechaFactura
				) {
		  if (i === this.contrato.facturacion.length - 1) {
						// Si es la última línea
						// Es el último, redondeamos
						cantidad = this.round(importeRestante - acumulado, 2)
		  }
		  this.contrato.facturacion[i].ImporteNeto = this.round(cantidad, 2)
		  acumulado = this.round(acumulado + cantidad, 2)
				}
	  }

	  this.calculaImporteTotal()

	  this.$emit('update:contrato', this.contrato)

	  this.$forceUpdate()
		},

		calculaImporteTotal () {
	  if (!this.FacturacionEnNeto) {
				let acumulado = 0
				for (let i = 0; i < this.contrato.facturacion.length; i++) {
		  const linea = this.contrato.facturacion[i]
		  const importeTotal = linea.ImporteTotal
		  const meses = this.contrato.facturacion.length

		  const total = this.contrato.lineas.reduce((acc, lineaContrato) => {
						if (importeTotal === 0 || isNaN(importeTotal)) {
			  return acc
						}
						const netoL = lineaContrato.ImporteNeto
						const netoMes = netoL / meses
						const totalL = lineaContrato.ImporteTotal
						const totalMes = totalL / meses

						const porcentaje = (importeTotal * 100) / totalMes
						const totalLinea =
			  (netoMes * porcentaje) / 100 / this.contrato.lineas.length
						acc = acc + totalLinea
						return this.round(acc, 2)
		  }, 0)

		  for (let j = 0; j < this.contrato.facturacion.length; j++) {
						if (
			  this.contrato.facturacion[j].FacturacionID === linea.FacturacionID
						) {
			  this.contrato.facturacion[j].ImporteNeto = total
			  acumulado = acumulado + total
						}
		  }

		  if (this.contrato.facturacion.length - 1 === i) {
						// El la última línea de facturación
						if (this.importeNeto !== acumulado) {
			  this.contrato.facturacion[this.contrato.facturacion.length - 1].ImporteNeto = this.round(total + (this.importeNeto - acumulado), 2)
						}
		  }
				}
	  } else {
				let acumulado = 0
				for (let i = 0; i < this.contrato.facturacion.length; i++) {
		  const linea = this.contrato.facturacion[i]
		  const importeNeto = parseFloat(linea.ImporteNeto)
		  const meses = this.contrato.facturacion.length

		  const total = this.contrato.lineas.reduce((acc, lineaContrato) => {
						if (importeNeto === 0 || isNaN(importeNeto)) {
			  return acc
						}
						const netoL = lineaContrato.ImporteNeto
						const netoMes = netoL / meses
						const totalL = lineaContrato.ImporteTotal
						const totalMes = totalL / meses

						const porcentaje = (importeNeto * 100) / netoMes
						const totalLinea =
			  (totalMes * porcentaje) / 100 / this.contrato.lineas.length
						acc = acc + totalLinea
						return this.$options.filters.round(acc, 2)
		  }, 0)

		  for (let j = 0; j < this.contrato.facturacion.length; j++) {
						if (
			  this.contrato.facturacion[j].FacturacionID === linea.FacturacionID
						) {
			  this.contrato.facturacion[j].ImporteTotal = total
			  acumulado = acumulado + total
						}
		  }

		  if (this.contrato.facturacion.length - 1 === i) {
						// El la última línea de facturación
						if (this.importeNeto !== acumulado) {
			  this.contrato.facturacion[this.contrato.facturacion.length - 1].ImporteTotal = this.round(total + (this.importe - acumulado), 2)
						}
		  }
				}
	  }
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/contrato/facturacion.vue